
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import Meta from '@/components/common/Meta';
import '@/lib/polyfill';
import '@/styles/globals.css';
import 'animate.css';
import { relayStylePagination } from '@apollo/client/utilities';
import { ModalContainer, Toaster } from '@flyer/components';
import { LazyMotion } from 'framer-motion';
import { NextAdapter } from 'next-query-params';
import type { AppProps } from 'next/app';
import React, { type JSX, useMemo } from 'react';
import { QueryParamAdapter, QueryParamProvider } from 'use-query-params';
import type { GetLayout } from '@/types';
import { RemoteConfigProvider } from '@/providers/remote-config';
import { PreRouteProvider } from '@/providers/pre-route';
import MobileProvider from '@/providers/mobile';
import MessageProvider from '@/providers/message';
import { AuthProvider } from '@/providers/auth';
import ReactQueryProvider from '@/providers/react-query';
import { ApolloProviderWrapper, CreateClientOptions } from '@/lib/apollo';
import DomainNotFoundRedirection from '@/guards/DomainNotFoundRedirection';
import { GoogleTagManager } from '@next/third-parties/google';
type AppPropsWithComponentLayout<P = Record<string, string>> = AppProps<P> & {
    Component: AppProps['Component'] & {
        getLayout?: GetLayout;
    };
};
function Adapter(props: {
    children: (adapter: QueryParamAdapter) => React.ReactElement | null;
}) {
    return <NextAdapter {...props} shallow/>;
}
const defaultGetLayout: GetLayout = (page) => page;
const loadFeatures = () => import('@/lib/feature-motion').then((res) => res.domAnimation);
const createClientOptions: CreateClientOptions = {
    typePolicies: {
        LearnerProfile: {
            fields: {
                userAttempts: relayStylePagination(['filterBy']),
            },
        },
        Query: {
            fields: {
                checkPoints: relayStylePagination(['filterBy']),
                viewerUserAttempts: relayStylePagination(['filterBy']),
                // userAttempts: relayStylePagination(['filterBy']),
                schools: relayStylePagination(['filterBy']),
                schoolTestLevelRanks: relayStylePagination(['filterBy']),
                learnerChallengeRanks: relayStylePagination(['filterBy']),
                learnerTestLevelRanks: relayStylePagination(['filterBy']),
            },
        },
    },
};
// const myStatsigClient = new StatsigClient('client-68pNq8PHlCP4TQzxpiFPhOGwkwqPhmpVJmPcuH6ORDR', {
//   userID: 'anonymous',
// });
// myStatsigClient.initializeSync();
function App({ Component, pageProps }: AppPropsWithComponentLayout): JSX.Element {
    const getLayout = Component.getLayout || defaultGetLayout;
    const renderGoogleTag = useMemo(() => {
        return (<>
        <GoogleTagManager gtmId="GTM-PSXX3KN"/>
      </>);
    }, []);
    return (
    // <StatsigProvider client={myStatsigClient}>
    <>
      {renderGoogleTag}
      <QueryParamProvider adapter={Adapter}>
        {/* Apollo lo GraphQL, ReactQueryProvider lo REST v4 (src/api/v4) */}
        <ReactQueryProvider>
          <ApolloProviderWrapper pageProps={pageProps} options={createClientOptions}>
            <MobileProvider>
              <DomainNotFoundRedirection>
                <AuthProvider>
                  <RemoteConfigProvider>
                    <PreRouteProvider>
                      <MessageProvider>
                        <LazyMotion strict features={loadFeatures}>
                          <ModalContainer />
                          <Toaster />
                          {getLayout(<Component {...pageProps}/>)}
                          <Meta />
                        </LazyMotion>
                      </MessageProvider>
                    </PreRouteProvider>
                  </RemoteConfigProvider>
                </AuthProvider>
              </DomainNotFoundRedirection>
            </MobileProvider>
          </ApolloProviderWrapper>
        </ReactQueryProvider>
      </QueryParamProvider>
    </>
    // </StatsigProvider>
    );
}
const __Next_Translate__Page__1a047bfe2c3__ = App;

    export default __appWithI18n(__Next_Translate__Page__1a047bfe2c3__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
    });
  